/** Suggest a client slug that matches ClientSlug domain rules (a-z0-9 hyphenated). */
export const suggestClientSlug = (name: string): string => {
  const normalized = name
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/gu, "-")
    .replace(/^-+|-+$/gu, "");
  return normalized.slice(0, 80);
};
